// translate settings from env

let settings = {
  DISABLE_TABLE_AVATAR_IMG: process.env.VUE_APP_DISABLE_TABLE_AVATAR_IMG === 'true'
}
export default settings
